import React from 'react';
import {Link} from 'react-router-dom';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

export interface BreadcrumbsPreviousLinkProps {
    name: string;
    route: string;
}

export default function BreadcrumbsPreviousLink(props: BreadcrumbsPreviousLinkProps) {
    const {
        name,
        route,
    } = props;
    
    return (
        <>
            <Link
                to={route}
            >
                {name}
            </Link>
            <ArrowForwardIcon />
        </>
    );
}
